// src/pages/xray/XrayLobby/TabWanFailover.js
import React from 'react';

const TabWanFailover = ({
  selectedTabsWanFailover,
  setSelectedTabsWanFailover,
  priWanFailoverLines,
  secWanFailoverLines,
  voiceVsDataTraffic,
}) => {
  return (
    <>
      <div className="tabs mt-6 flex border-b">
        {['WAN1', 'WAN2', 'WAN FAILOVER', 'TRAFFIC PATH'].map(
          (label, index) => (
            <label
              key={index}
              className={`cursor-pointer px-2 py-1 border-t border-r border-l border-red-600 bg-red-300 ml-1 rounded-t-md ${
                selectedTabsWanFailover === `tabsWanFailover${index + 1}`
                  ? 'border-b-0 font-bold'
                  : 'border-red-600 bg-red-600 hover:bg-red-700 transition-colors duration-200 text-white'
              }`}
            >
              <input
                type="radio"
                className="hidden"
                name="tabs-group"
                checked={
                  selectedTabsWanFailover === `tabsWanFailover${index + 1}`
                }
                onChange={() =>
                  setSelectedTabsWanFailover(`tabsWanFailover${index + 1}`)
                }
              />
              {label}
            </label>
          )
        )}
      </div>

      <div className="px-6 py-2 bg-white shadow-lg rounded-lg">
        {selectedTabsWanFailover === 'tabsWanFailover1' && (
          <div>
            <h1 className="font-bold text-2xl p-2">PRIMARY WAN IP Address</h1>
            <pre className="bg-gray-100 p-4 rounded-md border">
              {priWanFailoverLines?.[0] || 'No Primary WAN IP available'}
            </pre>
          </div>
        )}

        {selectedTabsWanFailover === 'tabsWanFailover2' && (
          <div>
            <h1 className="font-bold text-2xl p-2">SECONDARY WAN IP Address</h1>
            <pre className="bg-gray-100 p-4 rounded-md border">
              {secWanFailoverLines?.[0] || 'No Secondary WAN IP available'}
            </pre>
          </div>
        )}

        {selectedTabsWanFailover === 'tabsWanFailover3' && (
          <div>
            <h1 className="font-bold text-2xl p-2">WAN Circuits redundancy</h1>
            {priWanFailoverLines?.length || secWanFailoverLines?.length ? (
              <div className="flex gap-4">
                <div className="flex-1">
                  <h2 className="font-bold text-lg mb-2 text-blue-700">
                    Primary Circuit (PRI)
                  </h2>
                  <pre className="bg-gray-100 p-4 rounded-md border min-h-[200px]">
                    {priWanFailoverLines.length > 0
                      ? priWanFailoverLines.join('\n')
                      : 'No PRI data found.'}
                  </pre>
                </div>
                <div className="flex-1">
                  <h2 className="font-bold text-lg mb-2 text-green-700">
                    Secondary Circuit (SEC)
                  </h2>
                  <pre className="bg-gray-100 p-4 rounded-md border min-h-[200px]">
                    {secWanFailoverLines.length > 0
                      ? secWanFailoverLines.join('\n')
                      : 'No SEC data found.'}
                  </pre>
                </div>
              </div>
            ) : (
              <pre className="bg-gray-100 p-4 rounded-md border">
                No WAN Circuits redundancy status available
              </pre>
            )}
          </div>
        )}

        {selectedTabsWanFailover === 'tabsWanFailover4' && (
          <div>
            <h1 className="font-bold text-2xl p-2">Voice vs Data TRAFFIC</h1>
            <pre className="bg-gray-100 p-4 rounded-md border">
              {voiceVsDataTraffic || 'No Voice vs Data Traffic info'}
            </pre>
          </div>
        )}
      </div>
    </>
  );
};

export default TabWanFailover;
